export default __webpack_public_path__ + "static/media/support.2d04f2a3.svg";